// extracted by mini-css-extract-plugin
export default {"hidden":"DelayedCloseButton_hidden__-zftm","visible":"DelayedCloseButton_visible__NoaH9"};